import { render, staticRenderFns } from "./MomentsText.vue?vue&type=template&id=6cba587c&scoped=true&"
import script from "./MomentsText.vue?vue&type=script&lang=js&"
export * from "./MomentsText.vue?vue&type=script&lang=js&"
import style0 from "./MomentsText.vue?vue&type=style&index=0&id=6cba587c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cba587c",
  null
  
)

export default component.exports